import React, { useEffect } from 'react';
import { Product } from '../data/products';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  product?: Product;
}

const SEOHead: React.FC<SEOProps> = ({
  title = 'T-RaX Car Care | Oto Bakım Ürünleri',
  description = 'T-RaX Car Care ile aracınızı koruyun. Seramik kaplama, boya koruma, temizlik ürünleri.',
  image = 'https://traxcarcareproducts.com/hero-car.png',
  url = 'https://traxcarcareproducts.com',
  type = 'website',
  product,
}) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('title', title);
    setMeta('description', description);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:image', image, true);
    setMeta('og:url', url, true);
    setMeta('og:type', type, true);
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', image);

    // Product Schema Markup
    if (product) {
      const existingScript = document.getElementById('product-schema');
      if (existingScript) existingScript.remove();

      const schema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.name,
        description: product.description,
        image: product.images[0] || image,
        brand: {
          '@type': 'Brand',
          name: product.brand,
        },
        offers: {
          '@type': 'Offer',
          url: url,
          priceCurrency: 'TRY',
          price: product.salePrice > 0 ? product.salePrice : product.regularPrice,
          availability: product.inStock
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
          itemCondition: 'https://schema.org/NewCondition',
          seller: {
            '@type': 'Organization',
            name: 'T-RaX Car Care',
          },
        },
        aggregateRating: product.reviewCount > 0 ? {
          '@type': 'AggregateRating',
          ratingValue: product.rating,
          reviewCount: product.reviewCount,
          bestRating: 5,
          worstRating: 1,
        } : undefined,
        category: product.categories.join(', '),
      };

      const script = document.createElement('script');
      script.id = 'product-schema';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);

      return () => {
        const s = document.getElementById('product-schema');
        if (s) s.remove();
      };
    }
  }, [title, description, image, url, type, product]);

  return null;
};

export default SEOHead;
